
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface TutorialHeaderProps {
  title: string;
  filters: string[];
  imageUrl: string;
}

const TutorialHeader = ({ title, filters, imageUrl }: TutorialHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <>
      <Button 
        variant="outline" 
        size="icon"
        className="h-10 w-10 mb-6"
        onClick={() => navigate('/tutorials')}
      >
        <ArrowLeft className="h-4 w-4" />
        <span className="sr-only">Back to Tutorials</span>
      </Button>

      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      
      <div className="flex gap-2 mb-6">
        {filters.map(filter => (
          <Badge key={filter} variant="secondary">{filter}</Badge>
        ))}
      </div>
      
      <div className="mb-4">
        <img 
          src={imageUrl} 
          alt={title} 
          className="w-full rounded-lg object-cover max-h-[400px]" 
        />
      </div>
    </>
  );
};

export default TutorialHeader;
